import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { BzTabModule } from 'app/shared/components/tab/tab.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from 'app/shared/shared.module';
import { ConnectInterfacesComponent } from './connect-interfaces/connect-interfaces.component';
import { ConnectInterfacesService } from './core/connect-interfaces.service';
import { ConnectInterfacesPropertiesComponent } from './connect-interfaces/connect-interfaces-properties/connect-interfaces-properties.component';
import { ConnectInterfacesAdvComponent } from './connect-interfaces/connect-interfaces-adv/connect-interfaces-adv.component';
import { ConnectConnectorsComponent } from './connect-connectors/connect-connectors.component';
import { ConnectConnectorsService } from './core/connect-connectors.service';
import { ConnectorsSapComponent } from './connect-connectors/connectors-sap/connectors-sap.component';
import { ConnectorsInterfaceComponent } from './connect-connectors/connectors-interface/connectors-interface.component';
import { ConnectEcmComponent } from './connect-ecm/connect-ecm.component';
import { ConnectEcmPropertiesComponent } from './connect-ecm/connect-ecm-properties/connect-ecm-properties.component';
import { ConnectEcmFoldersComponent } from './connect-ecm/connect-ecm-folders/connect-ecm-folders.component';
import { ConnectEcmService } from './core/connect-ecm.service';
import { PendingChangesConnectAlertComponent } from './modal-actions/connect-pendingchanges.component';
import { ConnectEcmFoldersListComponent } from './connect-ecm/connect-ecm-folders/connect-ecm-folders-list/connect-ecm-folders-list.component';
import { ExcelConnectorComponent } from './connect-excel/connect-excel.component';
import { ExcelConnectorItemDetailComponent } from './connect-excel/connect-excel-item-detail/connect-excel-item-detail.component';
import { ExcelConnectorListComponent } from './connect-excel/connect-excel-list/connect-excel-list.component';
import { StoreModule } from '@ngrx/store';
import { MANAGE_EXCEL_CONNECTOR_REDUCER } from './connect-excel/store/reducers/feature.reducers';
import { ConnectExcelService } from './core/connect-excel.service';
import { ExcelConnectorListEffects } from 'app/connect/connect-excel/store/effects/excel-connector-list.effects';
import { EffectsModule } from '@ngrx/effects';
import {ConnectSapCpComponent} from './connect-sap-cp/connect-sap-cp.component';
import {MANAGE_SAP_CP_REDUCER} from './connect-sap-cp/store/reducers/feature.reducers';
import {SapEffects} from './connect-sap-cp/store/effects/sap-effects';
import { SapConfigListComponent } from './connect-sap-cp/sap-config-list/sap-config-list.component';
import { SapConfigDetailComponent } from './connect-sap-cp/sap-config-detail/sap-config-detail.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AuthCodeGrantComponent } from './auth-code-grant/auth-code-grant.component';
import { OauthCallbackComponent } from './auth-code-grant/oauth-callback/oauth-callback.component';
import { ConectConfirmModalComponent } from './conect-confirm-modal/conect-confirm-modal.component';
import { ConnectProviderService } from './core/connect-provider.service';
import { ConnectProviderComponent } from './connect-provider/connect-provider.component';
import { ConnectProviderDetailComponent } from './connect-provider/connect-provider-detail/connect-provider-detail.component';
import { ConnectProviderTreeComponent } from './connect-provider/connect-provider-tree/connect-provider-tree.component';
import { ConnectReplicationDetailComponent } from './connect-provider/connect-replication-detail/connect-replication-detail.component';
import { ConnectVirtualizationDetailComponent } from './connect-provider/connect-virtualization-detail/connect-virtualization-detail.component';
import { ConnectReplicationDetailPropertiesComponent } from './connect-provider/connect-replication-detail/connect-replication-detail-properties/connect-replication-detail-properties.component';
import { ConnectReplicationDetailScheduleComponent } from './connect-provider/connect-replication-detail/connect-replication-detail-schedule/connect-replication-detail-schedule.component';
import { ConnectReplicationDetailDatapickerComponent } from './connect-provider/connect-replication-detail/connect-replication-detail-datapicker/connect-replication-detail-datapicker.component';
import { ConnectReplicationDetailLogComponent } from './connect-provider/connect-replication-detail/connect-replication-detail-log/connect-replication-detail-log.component';
import { ConnectTriggersComponent } from './connect-triggers/connect-triggers.component';
import { ConnectTriggersService } from './core/connect-triggers.service';
import { ConnectTriggersDetailComponent } from './connect-triggers/connect-triggers-detail/connect-triggers-detail.component';
import { BZG_MODAL_DATA } from 'bz-genome-angular';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
}

const effects_excel_connector_list = [ExcelConnectorListEffects, SapEffects];

@NgModule({
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BzTabModule,
    BrowserModule,
    FormsModule,
    SharedModule,
    EffectsModule.forFeature(effects_excel_connector_list),
    StoreModule.forFeature('excelConnector', MANAGE_EXCEL_CONNECTOR_REDUCER),
    StoreModule.forFeature('sapCpConfiguration', MANAGE_SAP_CP_REDUCER),

  ],
  declarations: [
    ConnectInterfacesComponent,
    ConnectInterfacesPropertiesComponent,
    ConnectInterfacesAdvComponent,
    ConnectConnectorsComponent,
    ConnectorsSapComponent,
    ConnectorsInterfaceComponent,
    ConnectEcmComponent,
    ConnectEcmPropertiesComponent,
    ConnectEcmFoldersComponent,
    PendingChangesConnectAlertComponent,
    ConnectEcmFoldersListComponent,
    ExcelConnectorComponent,
    ExcelConnectorItemDetailComponent,
    ExcelConnectorListComponent,
    ConnectSapCpComponent,
    SapConfigListComponent,
    SapConfigDetailComponent,
    AuthCodeGrantComponent,
    OauthCallbackComponent,
    ConectConfirmModalComponent,
    ConnectProviderComponent,
    ConnectProviderDetailComponent,
    ConnectProviderTreeComponent,
    ConnectReplicationDetailComponent,
    ConnectVirtualizationDetailComponent,
    ConnectReplicationDetailPropertiesComponent,
    ConnectReplicationDetailScheduleComponent,
    ConnectReplicationDetailDatapickerComponent,
    ConnectReplicationDetailLogComponent,
    ConnectTriggersComponent,
    ConnectTriggersDetailComponent
  ],
  exports: [
    ConnectInterfacesComponent,
    ConnectInterfacesPropertiesComponent,
    ConnectInterfacesAdvComponent,
    ConnectConnectorsComponent,
    ConnectorsSapComponent,
    ConnectorsInterfaceComponent,
    ConnectEcmComponent,
    ConnectEcmPropertiesComponent,
    ConnectEcmFoldersComponent,
    PendingChangesConnectAlertComponent,
    ConnectEcmFoldersListComponent,
    ExcelConnectorComponent,
    ExcelConnectorItemDetailComponent,
    ExcelConnectorListComponent,
    ConectConfirmModalComponent,
    ConnectProviderComponent,
    ConnectTriggersComponent,
    ConnectTriggersDetailComponent
  ],
  entryComponents: [PendingChangesConnectAlertComponent, ConectConfirmModalComponent],
  providers: [ConnectInterfacesService, ConnectConnectorsService, ConnectEcmService, ConnectExcelService, ConnectProviderService, ConnectTriggersService,
    {
      provide: BZG_MODAL_DATA,
      useValue: { message: '' },
    },
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConnectModule {

}
